export const AUTHENTICATE_DATA = 'authenticate-data';
export const QR_DATA = 'qr-data';